import '../css/resources.scss';
import {h, render} from 'preact';
import appLogger from '@core/LoggingProvider';
import {createSearchContext} from '@ultradent/upi-fuzzy-search';
import ResourcesService from '@services/ResourcesService';
import {jqueryDropDownMenu} from '@modules/lazy-imports';
import {Distributors} from './containers/Resources/Distributors';

$( document ).ready( async function () {

    var menus = $( '#page-content .dropDownSelect' );
    var sdsFilter = $( '#sdsFilter' );
    var sdsList = $( '#sds-resource-list' );

    const distList = document.getElementById( 'distributor-resource-list' );

    if ( distList ) {
        render( <Distributors/>, null, distList );
    }

    await jqueryDropDownMenu();

    menus = menus.dropDownSelect();

    $( '#intlCountrySelect .menu' ).on( 'click', 'a', function ( e ) {
        if ( !e.target.href ) {
            return;
        }

        $( document ).trigger( 'menu:close' );

        var href = e.target.href,
            cid = href.substr( href.lastIndexOf( 'cid=' ) + 4 ),
            resource_div = $( '#intlResourceData' ),
            loading_id = null;

        function display_data ( data ) {
            resource_div.hide().empty().html( data ).fadeIn();
        }

        function loading ( is_loading ) {
            // clear any previous loading timers
            if ( loading_id ) {
                clearTimeout( loading_id );
                loading_id = null;
            }

            if ( is_loading ) {
                loading_id = setTimeout( function () {
                    display_data( '<div><i class="loading small"></i>Loading...</div>' );
                }, 500 );
            }
        }

        loading( true );
        ResourcesService.getResourcesForCountry( cid )
            .then( data => display_data( data ) )
            .catch( error => {
                appLogger.capture( error );
                display_data( `
                    <div class="module paddedBlock error">
                        <span class="msg">There was an error while attempting to retrieve this information</span>
                    </div>
                ` );
            } )
            .then( () => {
                loading( false );
                menus.hideMenu();
            } );

        e.preventDefault();
        return false;
    } );

    // if sdsFilter present then create an indexed list of the resource list
    if ( sdsFilter ) {

        const resourceIndex = sdsList.find( 'li' ).map( ( i, item ) => {
            const $item = $( item );
            return {
                title: $item.text().trim(),
                href: $item.find( 'a' ).attr( 'href' ),
                node: $item
            };
        } );

        const
            sdsContext = createSearchContext( resourceIndex, ['title'] ),
            renderer = createSDSRenderer( sdsContext );

        // update list based on defualt input value
        if ( sdsFilter.val() ) {
            renderer( sdsFilter.val() );
        }

        sdsFilter.on( 'input', e => {
            renderer( e.target.value );
        } )
    }

    /**
     * HOC that returns a functoin that accepts a query to be executed in a given
     * search context provided from upi-fuzzy-search
     * @param  {upi-fuzzy-search} srchContext search context to execute query from
     * @return {Function(String)} HOC to execute query
     */
    function createSDSRenderer ( srchContext ) {
        return query => {
            const {results} = srchContext.query( query.trim() );
            sdsList.html( buildSDSList( results ) );
        }
    }

    function buildSDSList ( items ) {
        return items.map( item => {
            return item.node;
        } )
    }
} );
